<div class="alert alert-danger col col-12">
  <p><strong>{{ 'dealer-locked.title' | translate }}</strong></p>
  <p>{{ 'dealer-locked.reason' | translate }}: {{ ('api.type.dealerlockReason.' + lockReason) | translate }}</p>
  <p>{{ 'dealer-locked.text' | translate }}
    <a href="mailto:{{ 'dealer-locked.email' | translate }}">{{ 'dealer-locked.email' | translate }}</a></p>
</div>
